//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, onMounted } from '@vue/composition-api';
import { SfButton } from '@storefront-ui/vue';
import { useOrder } from '@bee-hole/coms';
import List from '~/components/Order/OrderList';
import AfterSalesDetail from '~/components/Order/AfterDetail';
import Paginate from '~/components/Paginate';

export default {
  name: 'OrderHistoryTab',
  components: {
    SfButton,
    List,
    AfterSalesDetail,
    Paginate
  },
  setup(props, { emit }) {
    const orders = ref([]);
    const totalOrders = ref(0);
    const currentOrder = ref(null);
    const queryParams = ref({ page_no: 1, page_size: 10 });

    const { orderLists, orderGet, total } = useOrder('orderList');

    const totalPageNo = computed(() => {
      return Math.ceil(totalOrders.value / queryParams.value.page_size) || 1;
    });

    const loadOrders = async () => {
      await orderGet({ 
        status: '', 
        page_no: queryParams.value.page_no, 
        page_size: queryParams.value.page_size 
      });
      orders.value = orderLists.value;
      totalOrders.value = total.value;
    };

    const handlePageChange = async (page) => {
      queryParams.value.page_no = page;
      await loadOrders();
    };

    const setCurrentOrder = (order) => {
      currentOrder.value = order;
    };

    const resetCurrentOrder = () => {
      currentOrder.value = null;
    };

    onMounted(() => {
      loadOrders();
    });

    return {
      orders,
      totalOrders,
      currentOrder,
      queryParams,
      totalPageNo,
      handlePageChange,
      setCurrentOrder,
      resetCurrentOrder,
      loadOrders
    };
  }
};
